import { render } from "./ProviderAdd.vue?vue&type=template&id=697f6ebf"
import script from "./ProviderAdd.vue?vue&type=script&lang=js"
export * from "./ProviderAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__